import React from 'react'
import { useAppSelector } from './hooks/useRedux'
import Routes from './routes'
import Layout from './components/Layout'
import Content from './components/Layout/Content'
import Sider from './components/Layout/Sider'
import GlobalStyles from './theme/GlobalStyles'
import 'antd/dist/antd.less'

const App: React.FC = () => {
  const isLoggedIn = useAppSelector(({ user }) => user.isLoggedIn)

  return (
    <>
      <GlobalStyles />

      <Layout>
        {isLoggedIn ? <Sider>Sider</Sider> : null}

        <Layout>
          <Content>
            <Routes />
          </Content>
        </Layout>
      </Layout>
    </>
  )
}

export default App
